export const CURRENCY_FMT = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const NUM_FMT = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: true,
});

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const [y, m, d] = value.split('-').map(Number);
  if (!y || !m || !d) return value;
  return `${m}/${d}/${y}`;
}

export function parseDateLocal(val: string): Date {
  const [y, m, d] = val.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function formatMoney(val: string | null): string {
  if (val == null || val === '') return '—';
  const n = parseFloat(val);
  return Number.isNaN(n) ? val : CURRENCY_FMT.format(n);
}

/**
 * Normalize pasted/typed numeric input to a plain decimal string for the API.
 * Supports en-US (1,234.56) and common EU (1.234,56 / 1234,56) formats.
 */
export function normalizeNumberInput(raw: string): string | null {
  const s = raw.trim();
  if (!s) return null;

  let cleaned = s.replace(/[$€£%\s]/g, '');
  const hasComma = cleaned.includes(',');
  const hasDot = cleaned.includes('.');

  if (hasComma && hasDot) {
    // Last separator is the decimal mark
    if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      cleaned = cleaned.replace(/,/g, '');
    }
  } else if (hasComma) {
    // 1,234 / 1,234,567 (thousands) vs 1234,56 (decimal)
    cleaned = /^\d{1,3}(,\d{3})+$/.test(cleaned)
      ? cleaned.replace(/,/g, '')
      : cleaned.replace(',', '.');
  } else if (/^\d{1,3}(\.\d{3})+$/.test(cleaned)) {
    // 1.234.567 (EU thousands, no decimal)
    cleaned = cleaned.replace(/\./g, '');
  }

  cleaned = cleaned.replace(/[^\d.-]/g, '');
  const match = cleaned.match(/^(-?)(\d*\.?\d*)/);
  cleaned = match ? `${match[1]}${match[2]}` : '';

  if (!cleaned || cleaned === '-' || cleaned === '.' || cleaned === '-.') return null;
  if (Number.isNaN(Number(cleaned))) return null;
  return cleaned;
}

export function parseMoney(v: string | null): number {
  if (v == null || v === '') return 0;
  const s = String(v);
  // API values are plain decimals ("1234.56") — keep parseFloat path identical.
  // Only normalize when the string looks like user-formatted input.
  const n = /[,€£$%\s]/.test(s)
    ? parseFloat(normalizeNumberInput(s) ?? '')
    : parseFloat(s);
  return Number.isNaN(n) ? 0 : n;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
